import React, { memo } from "react";

import { Flex, Icon, Text } from "@chakra-ui/react";

const FilterPanelTitleItem = ({ panel }) => {
  return (
    <Flex
      align={"center"}
      columnGap={"4px"}
      color={"red"}
      pb={"4px"}
      borderColor={"grey"}
      borderBottomWidth={"1px"}
    >
      <Icon as={panel?.icon} w={"20px"} h={"20px"} />
      <Text
        fontSize={"14px"}
        fontWeight={"400"}
        lineHeight={"1.3"}
        letterSpacing={"2%"}
        mb={"-5px"}
      >
        {panel?.title}
      </Text>
    </Flex>
  );
};

export default memo(FilterPanelTitleItem);
